import { cn } from "@/lib/utils";
import Image from "next/image";
import type { ComponentProps } from "react";

export default function ProductCardImageFlat({
  src,
  alt,
  width,
  height,
  hoverSrc,
  className,
  children,
  ...props
}: Omit<ComponentProps<typeof Image>, "src" | "alt"> & {
  src?: string;
  alt?: string;
  hoverSrc?: string;
}) {
  if (!src) {
    return null;
  }

  return (
    <figure className={cn("bg-primary-100 relative h-full", className)}>
      <Image
        className={cn(
          "h-full w-full object-contain mix-blend-multiply",
          hoverSrc && "group-hover/product-image:opacity-0",
        )}
        src={src}
        alt={alt ?? ""}
        width={width ?? 600}
        height={height ?? 600}
        {...props}
      />
      {hoverSrc && (
        <Image
          className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity group-hover/product-image:opacity-100"
          src={hoverSrc}
          alt={alt ?? ""}
          width={width ?? 600}
          height={height ?? 600}
        />
      )}
      {children}
    </figure>
  );
}
